<template>
	<div class="eFilter">
		<div v-if="!mappedEvents" class="eFilter__loading">
			<div class="loader loader-7"></div>
		</div>
		<transition name="allFiltersMod">
			<div
				@click.self="allFilters"
				v-if="allFiltersOpen"
				class="allFiltersModal"
			>
				<div class="allFiltersModal__right stickyFilter">
					<div @click="allFilters" class="stickyFilter__top">
						<p>Filters</p>
						<CloseFilter></CloseFilter>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openCalendar"
							:class="[
								eventTypesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Select date</p>
							<FilterCaret></FilterCaret>
						</div>
						<div v-if="calendarTrue">
							<EventPicker
								class="eFilter__calModal homePicker__dp datePick"
								v-model="datePicked"
								:disabled-dates="vueDatepickerOptions[0]"
								model-type="yy-m-d"
								inline
								auto-apply
							></EventPicker>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openEventTypes"
							:class="[
								eventTypesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Event type</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								eventTypesFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in eventTypes"
									:key="index"
								>
									<label class="listFilter__label" :for="item.title"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.title"
											:value="item.title"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openEventFeatures"
							:class="[
								eventFeaturesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Event features</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								eventFeaturesFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in eventFeatures"
									:key="index"
								>
									<label class="listFilter__label" :for="item.title"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.title"
											:value="item.title"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openEventSeries"
							:class="[
								eventSeriesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Event series</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								eventSeriesFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in eventSeries"
									:key="index"
								>
									<label class="listFilter__label" :for="item.title"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.title"
											:value="item.title"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openEventPrices"
							:class="[
								eventPricesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Price</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								eventPricesFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in eventPrices"
									:key="index"
								>
									<label class="listFilter__label" :for="item.title"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.title"
											:value="item.title"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="checkedCategories.length > 0 || datePicked !== null"
						class="stickyFilter__applyFilterDiv"
					>
						<div @click="allFilters" class="stickyFilter__applyFilterBtn">
							<p>Apply filters</p>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<div @click.self="closeAllFilters" class="eFilter__topMidBotWrapper gutter">
			<div class="filterPage__top">
				<div class="filterPage__leftTop">
					<div class="filterPage__wrapper">
						<div v-if="windowWidth > 768" class="filterPage__container">
							<div
								v-if="vueDatepickerOptions[0].dates.length"
								@click.self="openCalendar"
								:class="[
									calendarTrue
										? 'filterPage__filter filterPage__filter--open'
										: 'filterPage__filter',
								]"
							>
								<p>Select date</p>
								<FilterCaret></FilterCaret>
								<div v-if="calendarTrue">
									<EventPicker
										class="eFilter__cal homePicker__dp datePick"
										v-model="datePicked"
										:disabled-dates="vueDatepickerOptions[0]"
										model-type="yy-m-d"
										inline
										auto-apply
									></EventPicker>
								</div>
							</div>
						</div>
						<div v-if="windowWidth > 768" class="filterPage__container">
							<div
								@click.self="openEventTypes"
								:class="[
									eventTypesFilterOpen
										? 'filterPage__filter filterPage__filter--open'
										: 'filterPage__filter',
								]"
							>
								<p>Event type</p>
								<FilterCaret></FilterCaret>
								<div v-if="eventTypesFilterOpen" class="filterPage__listCont">
									<div @click="openEventTypes" class="filterPage__closeFilter">
										<CloseFilter></CloseFilter>
									</div>
									<ul class="filterPage__list listFilter">
										<li
											class="listFilter__li"
											v-for="(item, index) in eventTypes"
											:key="index"
										>
											<label class="listFilter__label" :for="item.title"
												>{{ item.title }}
												<input
													class="listFilter__cb"
													type="checkbox"
													:id="item.title"
													:value="item.title"
													v-model="checkedCategories"
												/>
												<span class="listFilter__displayBox"></span>
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div v-if="windowWidth > 768" class="filterPage__container">
							<div
								@click.self="openEventFeatures"
								:class="[
									eventFeaturesFilterOpen
										? 'filterPage__filter filterPage__filter--open'
										: 'filterPage__filter',
								]"
							>
								<p>Event features</p>
								<FilterCaret></FilterCaret>
								<div
									v-if="eventFeaturesFilterOpen"
									class="filterPage__listCont"
								>
									<div
										@click="openEventFeatures"
										class="filterPage__closeFilter"
									>
										<CloseFilter></CloseFilter>
									</div>
									<ul class="filterPage__list listFilter">
										<li
											class="listFilter__li"
											v-for="(item, index) in eventFeatures"
											:key="index"
										>
											<label class="listFilter__label" :for="item.title"
												>{{ item.title }}
												<input
													class="listFilter__cb"
													type="checkbox"
													:id="item.title"
													:value="item.title"
													v-model="checkedCategories"
												/>
												<span class="listFilter__displayBox"></span>
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div v-if="windowWidth > 768" class="filterPage__container">
							<div
								@click.self="openEventSeries"
								:class="[
									eventSeriesFilterOpen
										? 'filterPage__filter filterPage__filter--open'
										: 'filterPage__filter',
								]"
							>
								<p>Event series</p>
								<FilterCaret></FilterCaret>
								<div v-if="eventSeriesFilterOpen" class="filterPage__listCont">
									<div @click="openEventSeries" class="filterPage__closeFilter">
										<CloseFilter></CloseFilter>
									</div>
									<ul class="filterPage__list listFilter">
										<li
											class="listFilter__li"
											v-for="(item, index) in eventSeries"
											:key="index"
										>
											<label class="listFilter__label" :for="item.value"
												>{{ item.title }}
												<input
													class="listFilter__cb"
													type="checkbox"
													:id="item.title"
													:value="item.title"
													v-model="checkedCategories"
												/>
												<span class="listFilter__displayBox"></span>
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div v-if="windowWidth > 768" class="filterPage__container">
							<div
								@click.self="openEventPrices"
								:class="[
									eventPricesFilterOpen
										? 'filterPage__filter filterPage__filter--open'
										: 'filterPage__filter',
								]"
							>
								<p>Price</p>
								<FilterCaret></FilterCaret>
								<div v-if="eventPricesFilterOpen" class="filterPage__listCont">
									<div @click="openEventPrices" class="filterPage__closeFilter">
										<CloseFilter></CloseFilter>
									</div>
									<ul class="filterPage__list listFilter">
										<li
											class="listFilter__li"
											v-for="(item, index) in eventPrices"
											:key="index"
										>
											<label class="listFilter__label" :for="item.value"
												>{{ item.title }}
												<input
													class="listFilter__cb"
													type="checkbox"
													:id="item.title"
													:value="item.title"
													v-model="checkedCategories"
												/>
												<span class="listFilter__displayBox"></span>
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div
							@click="allFilters"
							:class="[
								allFiltersOpen
									? 'filterPage__filter filterPage__filter--open'
									: 'filterPage__filter',
							]"
						>
							<p>All filters</p>
							<img src="/lib/img/filters.png" alt="All Filters" />
						</div>
						<div
							@click="clearFilters"
							v-if="checkedCategories.length > 0 || datePicked"
							class="filterPage__clearFilter"
						>
							<p>Clear Filters</p>
						</div>
					</div>
				</div>
			</div>
			<div class="filterPage__middleCont">
				<div
					v-if="checkedCategories.length > 0 || datePicked !== null"
					class="filterPage__middle"
				>
					<li
						v-if="datePicked !== null"
						class="listFilter__li"
						@click="clearDatePicked"
					>
						<div class="listFilter__label">
							<p>{{ monthTop }}</p>
							<RemoveX></RemoveX>
						</div>
					</li>
					<li
						v-if="checkedCategories.includes(item.title)"
						class="listFilter__li"
						v-for="(item, index) in mergedFilters"
						:key="index"
					>
						<label class="listFilter__label" :for="item.title"
							>{{ item.title }}
							<input
								class="listFilter__cb"
								type="checkbox"
								:id="item.title"
								:value="item.title"
								v-model="checkedCategories"
							/>
							<RemoveX></RemoveX>
						</label>
					</li>
				</div>
			</div>
		</div>
		<div @click.self="closeAllFilters" class="eFilter__bottomWrap">
			<!-- <div v-if="loadingEvents" class="eFilter__loadingWrapper">
				<div class="loader loader-7"></div>
			</div> -->
			<div
				@click.self="closeAllFilters"
				v-if="filtersOpenBodyCover"
				class="eFilter__filterOpenBodyCover"
			></div>
			<div v-if="noEvents" class="eFilter__noEvents redactorStyles">
				<h2>
					Unfortunately, there are no events at this time for "{{
						noEventsForCategoryText
					}}"
				</h2>
			</div>
			<div
				v-if="
					(filteredEvents !== undefined && filteredEvents.length === 0) ||
					keysArray.length === 0
				"
				class="eFilter__noEvents redactorStyles"
			>
				<h2>
					Unfortunately, there are no events
					<span v-if="datePicked !== null && keysArray.length === 0"
						>on or after {{ monthTop }}</span
					>
					<span v-else>at this time</span> for "{{ noEventsForCategoryText }}"
				</h2>
			</div>
			<div
				v-if="datePickedButNoEventsForCategory"
				class="eFilter__noEvents redactorStyles"
			>
				<h2>
					There are no "{{ noEventsForCategoryText }}" events on {{ monthTop }}.
					Other "{{ noEventsForCategoryText }}" events:
				</h2>
			</div>

			<div
				@click.self="closeAllFilters"
				v-if="keysArray.length > 0"
				class="eFilter__bottom"
			>
				<div
					@click.self="closeAllFilters"
					v-for="(item, index) in keysArray.slice(0, amountOfDaysToShow)"
					:key="item"
					class="eFilter__eachArray"
				>
					<div class="eFilter__arrayTop">
						<div class="redactorStyles">
							<h2 v-if="keysValuesInRange[item][0]">
								{{ keysValuesInRange[item][0].dayOfWeek }},
								{{ keysValuesInRange[item][0].month }}
								{{ keysValuesInRange[item][0].dayOfMonth }}
							</h2>
						</div>
						<div
							v-if="
								(keysValuesInRange[item].length > 1 && windowWidth < 769) ||
								(keysValuesInRange[item].length == 3 && windowWidth < 769) ||
								keysValuesInRange[item].length > 3
							"
							class="homePicker__buttons"
						>
							<button @click="previous(`${index}`)">
								<img
									:class="[slideIndex[index] <= 0 ? 'eFilter__disabled' : '']"
									:src="svgLeft"
								/>
							</button>
							<button @click="next(`${index}`)">
								<img
									:class="[
										slideIndex[index] >=
										keysValuesInRange[keysArray[index]].length - 1
											? 'eFilter__disabled'
											: '',
									]"
									:src="svgRight"
								/>
							</button>
						</div>
					</div>

					<VueSlickCarousel ref="carousel" v-bind="slickOptions">
						<div
							v-for="(event, index) in keysValuesInRange[item]"
							:key="index"
							class="eFilter__carousel"
						>
							<div class="eFilter__carouselBlock">
								<a
									tabindex="0"
									:href="`${event.url}?date=${event.urlDate}&time=${event.urlTime}`"
								>
									<div class="eFilter__carouselImg">
										<div
											class="eFilter__badgeCont"
											v-if="
												event.badge !== null ||
												event.cancelled === true ||
												event.soldOut === true
											"
										>
											<div v-if="event.soldOut" class="eFilter__badge--red">
												<p>sold out</p>
											</div>
											<div v-if="event.cancelled" class="eFilter__badge--red">
												<p>cancelled</p>
											</div>
											<div
												v-for="(badge, index) in event.badge"
												:key="index"
												:class="badgeClass(badge)"
											>
												<p>{{ badge }}</p>
											</div>
										</div>

										<img
											v-if="event.image"
											:src="event.image"
											:alt="event.title"
										/>
									</div>
								</a>
								<div v-if="event.topline" class="eFilter__categories">
									{{ event.topline }}
								</div>
								<h4 class="eFilter__h4">
									{{ event.title }}
								</h4>
								<p class="eFilter__p">
									{{ event.time
									}}<span v-if="event.endTime">&#8212;{{ event.endTime }}</span>
									<span v-if="event.otherTimes.length > 0">
										<p
											class="eFilter__p eFilter__p--inline"
											v-for="(item, index) in event.otherTimes.slice(0, 2)"
											:key="index"
										>
											{{ item.time }}<span>&#8212;{{ item.endTime }}</span>
										</p>
									</span>
								</p>
								<p
									class="eFilter__p eFilter__p--otherTimes"
									v-if="event.otherAvailableTimes > 0"
								>
									+{{ event.otherAvailableTimes }} other
									<span v-if="event.otherAvailableTimes === 1">time</span
									><span v-if="event.otherAvailableTimes > 1">times</span>
								</p>
							</div>
							<div class="buttons">
								<div class="prmBtn prmBtn--darkOutline">
									<a
										tabindex="0"
										:href="`${event.url}?date=${event.urlDate}&time=${event.urlTime}`"
									>
										<p>Learn more</p>
									</a>
								</div>
							</div>
						</div>
					</VueSlickCarousel>
				</div>
				<div
					v-if="this.keysArray.length > this.amountOfDaysToShow"
					@click="showAll = true"
					class="eFilter__showMore"
				>
					<p>Show more</p>
					<ShowMore></ShowMore>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import VueSlickCarousel from 'vue-slick-carousel';
var Vue = require('vue');
import EventsCaret from './svg/EventsCaret';
import FilterCaret from './svg/FilterCaret';
import CloseFilter from './svg/CloseFilter';
import RemoveX from './svg/RemoveX';
import ShowMore from './svg/ShowMore';

export default {
	name: 'EventsFilter',
	props: {
		svgLeft: String,
		svgRight: String,
	},
	data() {
		return {
			calendarTrue: false,
			daysOfTheWeek: [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
			],
			monthsOfTheYear: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
			slickOptions: {
				slidesToScroll: 1,
				infinite: false,
				touchMove: true,
				speed: 500,
				cssEase: 'ease',
				easing: 'linear',
				accessibility: true,
				autoplay: false,
				draggable: true,
				swipe: true,
				arrows: true,
				edgeFriction: 0.0004,
				touchThreshold: 100,
				variableWidth: true,
			},
			slideIndex: {},
			datePicked: null,
			showAll: false,
			rawData: [],
			eventFeatures: [],
			eventTypes: [],
			eventSeries: [],
			eventPrices: [],
			mergedFilters: [],
			keysArray: [],
			keysValuesInRange: {},
			allFiltersOpen: false,
			eventTypesFilterOpen: false,
			eventPricesFilterOpen: false,
			eventSeriesFilterOpen: false,
			eventFeaturesFilterOpen: false,
			monthTop: null,
			mappedEvents: null,
			allIds: [],
			newUrl: null,
			checkedCategories: [],
			noEventsForCategoryText: '',
			datePickedButNoEventsForCategory: false,
			// loadingEvents: false,
			noEvents: false,
			endDate: null,
			windowWidth: null,
			validDates: [],
			invalidDates: [],
			savedStartDate: null,
			vueDatepickerOptions: [
				{
					to: new Date(),
					dates: [],
				},
			],
		};
	},
	components: {
		EventPicker: Datepicker,
		VueSlickCarousel,
		EventsCaret,
		FilterCaret,
		CloseFilter,
		RemoveX,
		ShowMore,
	},
	beforeMount() {
		this.getStartDates();
		this.fetchFilters();
		this.getSearch();
		this.getEvents();
	},
	mounted() {
		this.window();
		this.disableLeftArrows();
		let that = this;
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.window();
			});
		});
	},
	methods: {
		badgeClass(badge) {
			return {
				'eFilter__badge eFilter__badge--red': this.isRedBadge(badge),
				eFilter__badge: !this.isRedBadge(badge),
			};
		},
		isRedBadge(badge) {
			return badge === 'Sold Out' || badge === 'Cancelled';
		},
		disableLeftArrows() {
			this.slideIndex = {};
			this.keysArray.forEach((key, index) => {
				this.slideIndex[index] = 0;
			});
		},
		window() {
			this.windowWidth = $(window).width();
		},
		getSearch() {
			let search = window.location.search;
			let url = new URLSearchParams(search);
			if (url.get('category') === null) {
				return;
			}
			let category = url.get('category').split(',');
			if (category.length > 0) {
				this.checkedCategories = category;
			}
		},
		clearDatePicked() {
			this.datePicked = null;
			// this.getEventsForMonth(this.savedStartDate);
			// this.datePicked = this.savedStartDate;
		},
		allFilters() {
			this.eventFeaturesFilterOpen = false;
			this.eventSeriesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.allFiltersOpen = !this.allFiltersOpen;
		},
		closeAllFilters() {
			this.eventFeaturesFilterOpen = false;
			this.eventSeriesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.allFiltersOpen = false;
			this.calendarTrue = false;
		},
		clearFilters() {
			this.checkedCategories = [];
			this.getStartDates();
			this.fiveOrAll = 5;
			this.datePicked = null;
			this.showAll = false;
		},
		openEventPrices() {
			this.eventFeaturesFilterOpen = false;
			this.eventSeriesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.eventPricesFilterOpen = !this.eventPricesFilterOpen;
			this.calendarTrue = false;
		},
		openEventSeries() {
			this.eventFeaturesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.eventSeriesFilterOpen = !this.eventSeriesFilterOpen;
			this.calendarTrue = false;
		},
		openEventFeatures() {
			this.eventSeriesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.eventFeaturesFilterOpen = !this.eventFeaturesFilterOpen;
			this.calendarTrue = false;
		},
		openEventTypes() {
			this.eventSeriesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventFeaturesFilterOpen = false;
			this.eventTypesFilterOpen = !this.eventTypesFilterOpen;
			this.calendarTrue = false;
		},
		openCalendar() {
			this.eventSeriesFilterOpen = false;
			this.eventPricesFilterOpen = false;
			this.eventFeaturesFilterOpen = false;
			this.eventTypesFilterOpen = false;
			this.calendarTrue = !this.calendarTrue;
		},
		mergeAll() {
			this.mergedFilters = this.eventFeatures.concat(
				this.eventTypes,
				this.eventSeries,
				this.eventPrices
			);
		},
		fetchFilters() {
			this.getEventPrices();
			this.getEventFeatures();
			this.getEventSeries();
			this.getEventTypes();
		},
		next(index) {
			if (index) {
				let that = this;
				Vue.nextTick(function () {
					that.slideIndex[index] =
						that.$refs.carousel[index].$refs.innerSlider._self.currentSlide + 1;
				});
				that.$refs.carousel[index].next();
				that.$forceUpdate();
			}
		},
		previous(index) {
			if (index) {
				let that = this;
				Vue.nextTick(function () {
					that.slideIndex[index] =
						that.$refs.carousel[index].$refs.innerSlider._self.currentSlide - 1;
				});
				that.$refs.carousel[index].prev();
				that.$forceUpdate();
			}
		},
		getStartDates() {
			let today = new Date();
			today.setHours(0, 0, 0, 0);
			today = today.setDate(today.getDate() - 1);
			this.today = new Date(today);
			this.vueDatepickerOptions[0].to = new Date(today);
			// this.savedStartDate = new Date(today);
			this.$forceUpdate();
			let todayPlus = new Date();
			todayPlus.setHours(0, 0, 0, 0);
			this.endDate = new Date(todayPlus.setMonth(todayPlus.getMonth() + 9));
		},
		mapDateHelper(dateTimeString) {
			// Split the input date-time string at the space character
			const [datePart, timePart] = dateTimeString.split(' ');

			// Split the date part into year, month, and day
			const [year, month, day] = datePart.split('-');

			// Split the time part into hours, minutes, and seconds
			const [hours, minutes, seconds] = timePart.split(':');

			// Create a new Date object
			const dateObject = new Date(
				year,
				month - 1,
				day,
				hours,
				minutes,
				seconds
			);

			return dateObject;
		},
		validDateHelper(inputDate) {
			let dateParts = inputDate.split(' ');
			let abbreviatedDate = dateParts[0];
			// Split the input date string into its components
			const [year, month, day] = abbreviatedDate.split('-');

			// Create a new Date object
			const date = new Date(year, month - 1, day);

			// Define arrays for days of the week and months
			const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
			const months = [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			];

			// Get the components of the formatted date
			const dayOfWeek = daysOfWeek[date.getDay()];
			const monthName = months[date.getMonth()];
			const formattedDay = String(date.getDate()).padStart(2, '0');
			const formattedYear = date.getFullYear();
			const formattedHours = String(date.getHours()).padStart(2, '0');
			const formattedMinutes = String(date.getMinutes()).padStart(2, '0');
			const formattedSeconds = String(date.getSeconds()).padStart(2, '0');
			const timezoneOffset = date.getTimezoneOffset();
			const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60))
				.toString()
				.padStart(2, '0');
			const timezoneOffsetMinutes = (Math.abs(timezoneOffset) % 60)
				.toString()
				.padStart(2, '0');
			const timezoneOffsetSign = timezoneOffset > 0 ? '-' : '+';

			// Construct the formatted date string
			let formattedDate = `${dayOfWeek} ${monthName} ${formattedDay} ${formattedYear} ${formattedHours}:${formattedMinutes}:${formattedSeconds} GMT${timezoneOffsetSign}${timezoneOffsetHours}${timezoneOffsetMinutes}`;
			formattedDate = new Date(formattedDate);
			return formattedDate;
		},
		getEvents() {
			// this.loadingEvents = true;
			this.fiveOrAll = 5;
			let categoriesString = this.checkedCategories.toString();

			let today = new Date();
			today.setHours(0, 0, 0, 0);
			today = today.setDate(today.getDate() - 1);
			today = new Date(today);

			let that = this;
			$.get('/api/v1/event-filter', function (res) {
				that.rawData = res.data;
				let dateArray = [];
				res.data.forEach((elem) => {
					elem.dateMatrix.matrixBlock.forEach((item) => {
						let itemDate = that.validDateHelper(item.eventDateTime.date);
						if (itemDate > today) {
							that.validDates.push(itemDate.getTime());
						}
					});
				});
			});
		},
		tConvert(time) {
			// Check correct time format and split into components
			time = time
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				// If time format correct
				time = time.slice(1); // Remove full string match value
				time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
				time[0] = +time[0] % 12 || 12; // Adjust hours
			}

			return time.join(''); // return adjusted time or original string
		},
		setMonthTop(varDate) {
			let month = new Date(varDate).getMonth();
			let monthWord = this.monthsOfTheYear[month];
			let year = new Date(varDate).getFullYear();
			let day = new Date(varDate).getDate();
			this.monthTop = monthWord + ' ' + day + ', ' + year;
		},

		getEventSeries() {
			let that = this;
			$.get('/api/v1/eventSeries', function (res) {
				res.data.forEach((el) => {
					that.eventSeries.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		getEventFeatures() {
			let that = this;
			$.get('/api/v1/eventFeatures', function (res) {
				res.data.forEach((el) => {
					that.eventFeatures.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		getEventPrices() {
			let that = this;
			$.get('/api/v1/eventPrices', function (res) {
				res.data.forEach((el) => {
					that.eventPrices.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		getEventTypes() {
			let that = this;
			$.get('/api/v1/eventTypes', function (res) {
				res.data.forEach((el) => {
					that.eventTypes.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		mapEvents() {
			let arrayAll = [];

			this.rawData.forEach((item) => {
				// Sort the matrixBlock array by event start time
				item.dateMatrix.matrixBlock.sort((a, b) => {
					return (
						moment(a.eventDateTime.date).valueOf() -
						moment(b.eventDateTime.date).valueOf()
					);
				});
				let categories = [];
				if (item.eventCategories.length > 0) {
					categories = item.eventCategories.map((category) => category);
				}
				let groupedEvents = {};
				let eventCounts = {}; // Track occurrences of events with the same title per date

				item.dateMatrix.matrixBlock.forEach((dateItem) => {
					const presentationDate = this.mapDateHelper(
						dateItem.eventDateTime.date
					);
					const matchDate = this.validDateHelper(
						dateItem.eventDateTime.date
					).getTime();
					const dateKey = presentationDate.toISOString().split('T')[0]; // Unique key per date
					const eventTitle = item.title;

					let time = this.tConvert([
						moment(presentationDate).format('h:mm a'),
					]).replace(':00', '');
					let endTime = null;

					if (dateItem.eventEndDate) {
						const end = this.mapDateHelper(dateItem.eventEndDate.date);
						endTime = this.tConvert([moment(end).format('h:mm a')]).replace(
							':00',
							''
						);
					}

					if (
						endTime !== null &&
						((time.includes('am') && endTime.includes('am')) ||
							(time.includes('pm') && endTime.includes('pm')))
					) {
						time = time.slice(0, -3);
					}

					// Initialize event count tracking
					if (!eventCounts[dateKey]) {
						eventCounts[dateKey] = {};
					}
					eventCounts[dateKey][eventTitle] =
						(eventCounts[dateKey][eventTitle] || 0) + 1;

					if (!groupedEvents[dateKey]) {
						// If this is the first instance of the event on this date, create a new object
						groupedEvents[dateKey] = {
							title: eventTitle,
							url: item.url,
							topline: item.topline,
							badge: item.badge.filter((el) => el != null),
							categories: categories,
							image: item.image,
							presentationDate,
							matchDate,
							year: presentationDate.getFullYear(),
							dayOfWeek: this.daysOfTheWeek[presentationDate.getDay()],
							dayOfMonth: presentationDate.getDate(),
							month: this.monthsOfTheYear[presentationDate.getMonth()],
							time: time,
							endTime: endTime,
							tessId: dateItem.tessId !== null ? dateItem.tessId : undefined,
							cancelled: dateItem.cancelled,
							soldOut: dateItem.soldOut,
							urlDate: dateKey,
							urlTime: moment(dateItem.eventDateTime.date).format('hh:mm'),
							otherTimes: [],
							otherAvailableTimes: 0, // Default, will update later
						};
					} else {
						// If there are multiple times for this date, store them in otherTimes
						groupedEvents[dateKey].otherTimes.push({ time, endTime });
					}
				});

				// Update `otherAvailableTimes` based on counted occurrences
				Object.keys(groupedEvents).forEach((dateKey) => {
					if (eventCounts[dateKey] && groupedEvents[dateKey]) {
						const eventTitle = groupedEvents[dateKey].title;
						let totalEvents = eventCounts[dateKey][eventTitle] || 0;
						groupedEvents[dateKey].otherAvailableTimes = Math.max(
							totalEvents - 3,
							0
						); // Ensure non-negative values
					}
				});

				// Push all grouped event objects into arrayAll
				arrayAll.push(...Object.values(groupedEvents));
			});

			arrayAll = arrayAll.flat();

			const today = new Date();
			today.setHours(0, 0, 0, 0); // Normalize to start of day

			// Filter presentations with dates on or after today
			arrayAll = arrayAll.filter((presentation) => {
				const presentationDate = new Date(presentation.presentationDate);
				return presentationDate >= today;
			});

			// Sort events by date
			this.mappedEvents = arrayAll.sort(
				(a, b) => new Date(a.presentationDate) - new Date(b.presentationDate)
			);

			// Store tessId values
			this.allIds = this.mappedEvents
				.filter((item) => item.tessId !== undefined && !item.otherEvents) // Exclude items with otherEvents
				.map((item) => item.tessId);

			this.$forceUpdate();
		},
		getEventsForMonth(selectedDate) {
			if (!this.filteredEvents || !selectedDate) {
				return;
			}
			this.keysValuesInRange = [];
			this.keysArray = [];

			let firstOfNextMonth = new Date(selectedDate);
			firstOfNextMonth.setDate(1);

			firstOfNextMonth.setMonth(firstOfNextMonth.getMonth() + 6);
			let selectedDatesObject = {};
			this.filteredEvents.forEach((obj) => {
				const timestamp = obj.matchDate; // Get the Unix timestamp from the object

				// Check if the key (Unix timestamp) already exists in the organizedData object
				if (!selectedDatesObject.hasOwnProperty(timestamp)) {
					// If not, initialize it as an empty array
					selectedDatesObject[timestamp] = [];
				}

				// Push the object into the corresponding Unix timestamp key
				selectedDatesObject[timestamp].push(obj);
			});

			let selectedDateToUnix = new Date(selectedDate);
			selectedDateToUnix.setHours(0, 0, 0, 0);

			// Get the Unix timestamp
			const selectedDateTimestamp = Math.floor(selectedDateToUnix.getTime()); // Divide by 1000 to convert from milliseconds to seconds

			let firstOfMonthtoUnix = new Date(firstOfNextMonth);
			firstOfMonthtoUnix.setHours(0, 0, 0, 0);
			const firstOfTimestamp = Math.floor(firstOfMonthtoUnix.getTime());

			const keysValuesInRange = {};

			// Iterate through the keys of the object
			for (const key in selectedDatesObject) {
				if (selectedDatesObject.hasOwnProperty(key)) {
					const timestamp = parseInt(key);

					// Check if the timestamp is greater than or equal to unixTimestamp1
					// and less than unixTimestamp2
					if (
						timestamp >= selectedDateTimestamp &&
						timestamp < firstOfTimestamp
					) {
						keysValuesInRange[timestamp] = [];
					}
				}
			}
			this.filteredEvents.forEach((event) => {
				const matchDate = event.matchDate;
				if (keysValuesInRange[matchDate]) {
					keysValuesInRange[matchDate].push(event);
				}
			});
			this.keysValuesInRange = keysValuesInRange;
			this.keysArray.push(...Object.keys(this.keysValuesInRange));
			// this.loadingEvents = false;
			this.$forceUpdate();
		},
		checkDatePickedIfCategoryChecked() {
			if (
				this.datePicked !== null &&
				this.keysArray &&
				this.keysArray.length > 0 &&
				this.checkedCategories.length > 0
			) {
				let keysValue = this.keysArray[0];
				if (keysValue) {
					let date1 = this.keysValuesInRange[keysValue][0].presentationDate;
					const date2 = new Date(this.datePicked);
					// Extract year, month, and date
					const isSameDate =
						date1.getFullYear() === date2.getFullYear() &&
						date1.getMonth() === date2.getMonth() &&
						date1.getDate() === date2.getDate();
					if (!isSameDate) {
						this.datePickedButNoEventsForCategory = true;
					} else {
						this.datePickedButNoEventsForCategory = false;
					}
				}
			} else {
				this.datePickedButNoEventsForCategory = false;
			}
		},
	},

	watch: {
		eventFeatures() {
			this.mergeAll();
		},
		eventTypes() {
			this.mergeAll();
		},
		eventSeries() {
			this.mergeAll();
		},
		eventPrices() {
			this.mergeAll();
		},
		newUrl() {
			this.keysArray = [];
			this.keysValuesInRange = [];
		},
		checkedCategories(cats) {
			let currentUrl = window.location.search;
			let currentParams = new URLSearchParams(currentUrl.search);
			let arrayToString = this.checkedCategories.toString();
			if (this.checkedCategories.length === 0) {
				currentParams.delete('category');
				let newUrl = window.location.pathname;
				newUrl = decodeURIComponent(newUrl);
				history.pushState(null, '', newUrl);
				this.newUrl = newUrl;
				this.noEventsForCategoryText = '';
			} else {
				currentParams.set('category', arrayToString);
				let newUrl = window.location.pathname + '?' + currentParams;
				newUrl = decodeURIComponent(newUrl);
				history.pushState(null, '', newUrl);
				this.newUrl = newUrl;
				let textForCategory = this.checkedCategories.join(', ');

				this.noEventsForCategoryText = textForCategory;
			}
		},
		mappedEvents(mappedEvents) {
			if (this.mappedEvents !== null && this.mappedEvents.length > 0) {
				const ids = this.allIds.join(',').toString();
				let that = this;

				$.get(
					'/actions/my-module/default/available-tickets-check',
					{ arrayOfIds: ids },
					function (res) {
						let jsonRes;

						// Safely parse the JSON response
						try {
							jsonRes = JSON.parse(res);
						} catch (error) {
							console.error('Error parsing API response:', error);
							return;
						}

						// Process each performance
						Object.values(jsonRes).forEach((performance) => {
							if (!performance || !performance.PerformanceId) {
								console.warn('Skipping invalid performance data:', performance);
								return; // Skip this iteration if PerformanceId is missing
							}

							let performanceId = performance.PerformanceId.toString(); // Safe conversion

							// Update each mapped event that matches this PerformanceId
							that.mappedEvents.forEach((event) => {
								if (event.tessId && event.tessId === performanceId) {
									event.soldOut = performance.AvailableCount === 0;
								}
							});
						});
					}
				);

				// Refresh the event list for the selected month
				// that.getEventsForMonth(that.datePicked);
			} else {
				// Handle case where there are no events
				let textForCategory = this.checkedCategories
					.join(', ')
					.replace('over-20', 'over $20')
					.replace('under-20', 'under $20')
					.replaceAll('-', ' ');

				this.noEventsForCategoryText = textForCategory;
				this.noEvents = true;
			}
		},
		datePicked(date) {
			if (this.mappedEvents === null) {
				return;
			}
			if (date === null) {
				this.getEventsForMonth(this.savedStartDate);
				return;
			}
			this.keysArray = [];
			this.keysValuesInRange = {};
			if (typeof this.datePicked === 'object') {
				let newDate = new Date(this.datePicked).getTime();
				this.getEventsForMonth(newDate);
			} else {
				this.getEventsForMonth(this.datePicked);
			}
			this.setMonthTop(this.datePicked);
			if (this.calendarTrue === true) {
				this.openCalendar();
			}
		},
		rawData(rawData) {
			if (this.rawData.length > 0) {
				this.noEvents = false;
				this.mapEvents();
			} else {
				this.noEvents = true;
			}
		},
		validDates(n) {
			if (!n || this.validDates.length == 0 || this.datePicked !== null) {
				return;
			}
			let valid = [];
			for (
				var arr = [], dt = new Date(this.today);
				dt <= new Date(this.endDate);
				dt.setDate(dt.getDate() + 1)
			) {
				// gives datepicker dates to block out.
				if (this.validDates.indexOf(new Date(dt).getTime()) === -1) {
					this.vueDatepickerOptions[0].dates.push(new Date(dt));
					arr.push(new Date(dt));
				} else {
					valid.push(new Date(dt));
				}
			}
			valid = valid.sort((a, b) => b.date - a.date);
		},
		keysArray(val) {
			this.datePickedButNoEventsForCategory = false;
			if (this.keysArray !== null) {
				this.disableLeftArrows();
				this.checkDatePickedIfCategoryChecked();
			}
		},
		filteredEvents() {
			if (this.filteredEvents) {
				if (this.datePicked) {
					this.getEventsForMonth(this.datePicked);
				} else {
					this.getEventsForMonth(this.savedStartDate);
				}
			}
		},
	},
	computed: {
		filtersOpenBodyCover() {
			if (
				this.calendarTrue == true ||
				this.eventPricesFilterOpen == true ||
				this.eventSeriesFilterOpen == true ||
				this.eventTypesFilterOpen == true ||
				this.eventFeaturesFilterOpen == true
			) {
				return true;
			} else {
				return false;
			}
		},
		amountOfDaysToShow() {
			if (this.showAll) return this.keysArray.length;
			if (this.keysArray.length === 0) return 5;
			if (this.checkedCategories.length === 0 && this.datePicked === null)
				return 5;

			if (this.checkedCategories.length > 0 || this.datePicked !== null) {
				return this.keysArray.length;
			}
			return 5;
		},
		filteredEvents() {
			if (!this.mappedEvents) {
				return;
			}
			this.checkedCategories = this.checkedCategories;
			let filteredEvents = this.mappedEvents;
			this.savedStartDate = new Date(this.mappedEvents[0].presentationDate);
			if (this.checkedCategories.length > 0) {
				// return filteredEvents.filter((event) =>
				// 	event.categories.some((category) =>
				// 		this.checkedCategories.includes(category)
				// 	)
				// );
				return filteredEvents.filter((event) =>
					this.checkedCategories.every((category) =>
						event.categories.includes(category)
					)
				);
			} else {
				return filteredEvents;
			}
		},
	},
};
</script>
